import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../../../components/Logo';
import Dropdown from '../../../components/Dropdown';
import MaxWidthContainer from '../../../components/MaxWidthContainer';
import { MenuItem } from "@blueprintjs/core";
import styled from 'styled-components';
import ScrollSpy from 'react-scrollspy';
import { HashLink } from 'react-router-hash-link';
import { capitalize, formatPxToNumber, getSections } from '../../../utils';
import theme from '../../../theme';
import './index.css';

const SECTIONS = getSections();
const SHADOW = '0 3px 8px 0 rgba(0,0,0,.3)';

const CustomNavbar = styled.div`
  box-shadow: ${props => props.showBorder ? SHADOW : 'none'} !important;
  -webkit-box-shadow: ${props => props.showBorder ? SHADOW : 'none'} !important;
  transition: box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const NavbarContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Section = styled.div`
  vertical-align: center;
`;

const HorizontalSections = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-start: center;
  @media (max-width: ${theme.smallScreenCutoff}) {
    display: none;
  }
`;


const VerticalSections = styled.div`
  @media (min-width: ${theme.smallScreenCutoff}) {
    display: none;
  }
`;

function handleScroll(el) {
  el.scrollIntoView({
    behavior: "smooth",
    block: "start",
    inline: "nearest"
  })
}

const sectionKeys = Object.keys(SECTIONS);
const sectionIds = [];
const sections = [];
sectionKeys.forEach(sectionKey => {
  sectionIds.push(SECTIONS[sectionKey]);
  sections.push(
    <Section key={sectionKeys.indexOf(sectionKey)}>
      <HashLink
        className="section-title"
        to={`#${SECTIONS[sectionKey]}`}
        scroll={handleScroll}
      >
        {capitalize(SECTIONS[sectionKey])}
      </HashLink>
    </Section>
  );
});

const menuItems = [];
sectionKeys.forEach(sectionKey => {
  const text = capitalize(SECTIONS[sectionKey]);
  if (text !== ' ') {
    const item = (
      <HashLink
        key={sectionKeys.indexOf(sectionKey)}
        className="section-title"
        to={`#${SECTIONS[sectionKey]}`}
        scroll={handleScroll}
      >
        <MenuItem text={capitalize(SECTIONS[sectionKey])}/>
      </HashLink>
    );
    menuItems.push(item);
  }
});

class Navbar extends React.Component {

  render() {

    const logo = (
      <HashLink
        className="navbar-title"
        to={`#${SECTIONS.hero}`}
        scroll={handleScroll}
      >
        <Logo />
      </HashLink>
    );

    return (
      <CustomNavbar showBorder={this.props.showBorder}
                    className="pt-navbar pt-fixed-top"
      >
        <MaxWidthContainer>
          <NavbarContent>
            {logo}
            <HorizontalSections>
              <ScrollSpy
                items={sectionIds}
                currentClassName="section-title-active"
                offset={-formatPxToNumber(theme.ptNavbarHeight) - 1}
                className="flex-center-row"
              >
                {sections}
              </ScrollSpy>
            </HorizontalSections>
            <VerticalSections>
              <Dropdown menuItems={menuItems}/>
            </VerticalSections>
          </NavbarContent>
        </MaxWidthContainer>
      </CustomNavbar>
    );
  }
}

Navbar.propTypes = {
  showBorder: PropTypes.bool.isRequired
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/Navbar/index.js